export function cubicIn(t) {
  return t * t * t;
}

export function cubicOut(t) {
  return --t * t * t + 1;
}

export function cubicInOut(t) {
  return ((t *= 2) <= 1 ? t * t * t : (t -= 2) * t * t + 2) / 2;
}



//////////////////
// WEBPACK FOOTER
// ../~/d3-ease/src/cubic.js
// module id = ropQ
// module chunks = 0